import React from 'react';
import { common } from '@kurtosys/ksys-app-template';

import { ILinePropsLastLabel } from '../../../../models/charting/index.js';
import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import { CHART_BASE_CATEGORY_KEY, CHART_BASE_COMPONENT_KEY } from '../ChartBase.meta.js';

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledLastSeriesLabel = InjectedStyledComponent('text', CHART_BASE_CATEGORY_KEY, CHART_BASE_COMPONENT_KEY, [
	'lastSeriesLabel',
]);

// eslint-disable-next-line @typescript-eslint/naming-convention
const LastSeriesLabel = (props: any) => {
	const {
		translationContext,
		overrides,
		seriesProps,
		index,
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		viewBox,
		stroke,
		value: rawValue,
		content,
		...otherProps
	} = props;
	const { enabled, valueFormat, props: overrideProps = {} } = overrides as ILinePropsLastLabel;
	if (valueFormat) {
		if (!valueFormat.locale) {
			valueFormat.locale = translationContext && translationContext.culture;
		}
		if (!valueFormat.options) {
			valueFormat.options = {};
		}
	}
	const value = valueFormat ? common.commonUtils.formatter(valueFormat, rawValue) : rawValue;
	if (enabled && seriesProps && seriesProps.length > 0 && seriesProps.length === index + 1) {
		return (
			<StyledLastSeriesLabel fill={stroke} {...otherProps} {...overrideProps}>
				{value}
			</StyledLastSeriesLabel>
		);
	}
	return null;
};

export default LastSeriesLabel;
